import { Timestamp } from 'firebase/firestore';

/**
 * Enum for lesson formats
 */
export enum LessonFormat {
  VIDEO = 'video',
  DOCUMENT = 'document',
  LINK = 'link'
}

/**
 * Interface for lesson content
 */
export interface LessonContent {
  videoUrl?: string;
  documentUrl?: string;
  externalLinks?: string[];
  notes?: string;
}

/**
 * Interface for lesson
 */
export interface Lesson {
  id: string;
  title: string;
  description: string;
  category: string;
  icon: string;
  estimatedTime: number;
  formats: LessonFormat[];
  content: LessonContent;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

/**
 * Interface for new lesson (without id)
 */
export interface NewLesson {
  title: string;
  description: string;
  category: string;
  icon: string;
  estimatedTime: number;
  formats: LessonFormat[];
  content: LessonContent;
}

/**
 * Interface for category
 */
export interface Category {
  id: string;
  name: string;
  description?: string;
  order?: number;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

/**
 * Interface for new category (without id)
 */
export interface NewCategory {
  name: string;
  description?: string;
  order?: number;
}

/**
 * Interface for user progress
 */
export interface UserProgress {
  id: string;
  userId: string;
  lessonId: string;
  completed: boolean;
  completedAt?: Timestamp;
}

/**
 * Props for LessonCard component
 */
export interface LessonCardProps {
  lesson: Lesson;
  isCompleted?: boolean;
  onClick: () => void;
}

/**
 * Props for CategoryProgressCard component
 */
export interface CategoryProgressProps {
  category: Category;
  totalLessons: number;
  completedLessons: number;
}